import React, { useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import accountService from "../../services/account/account.service";
import { ChangePasswordDto } from "../../services/account/account.dto";
import { useToast } from "../../utils/toast";
import FormikValueIsValid from "../../utils/FormikValueIsValid";

const ChangePasswordPage = () => {
  const { t } = useTranslation();
  const toast = useToast();

  const navigate = useNavigate();
  const containerClassName = classNames(
    "surface-ground flex align-items-center justify-content-center overflow-hidden"
  );

  const formik = useFormik<ChangePasswordDto>({
    initialValues: {
      currentPassword: "",
      newPassword: ""
    },
    enableReinitialize: true,
    validate: (data) => {
      const errors: any = {};

      if (data.currentPassword === undefined || data.currentPassword === "") {
        errors.currentPassword = t("PasswordIsRequired");
      }

      if (data.newPassword === undefined || data.newPassword === "") {
        errors.newPassword = t("PasswordIsRequired");
      }

      return errors;
    },
    onSubmit: (values) => {
      accountService.ChangePassword(values).then((res) => {
        if (res.result && !res.result?.error) {
          toast.show(t("ChangePasswordMessage"), "success");
          navigate("/", { replace: true });
        }
      });
    }
  });

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  return (
    <form className={containerClassName} onSubmit={formik.handleSubmit}>
      <div className="flex flex-column align-items-center justify-content-center p-3">
        <div
          className="surface-card border-1 surface-border border-round-2xl shadow-3 p-4 sm:p-5 md:p-6 w-full"
          style={{ maxWidth: "460px" }}
        >
          <div className="text-center mb-5">
            <img src="/images/logoosbuk.png" alt="OSBÜK Logo" height="48" className="mb-3" />
            <div className="text-900 text-2xl sm:text-3xl font-bold mb-2">{t("PasswordChange")}</div>
            <span className="text-600 text-sm">Mevcut ve yeni şifrenizi girerek güncelleyiniz</span>
          </div>

          <div className="mb-4">
            <label htmlFor="currentPassword" className="block text-900 font-medium mb-2">
              {t("CurrentPassword")}
            </label>
            <div className="relative w-full">
              <InputText
                id="currentPassword"
                type={showCurrentPassword ? "text" : "password"}
                placeholder={t("CurrentPassword")}
                className={classNames("w-full p-3 pr-6", {
                  "p-invalid": FormikValueIsValid(formik, "currentPassword")
                })}
                value={formik.values.currentPassword}
                onChange={(e) => formik.setFieldValue("currentPassword", e.target.value)}
              />
              <i
                className={`pi ${showCurrentPassword ? "pi-eye-slash" : "pi-eye"} cursor-pointer text-600 hover:text-900 absolute`}
                style={{ right: "1rem", top: "50%", transform: "translateY(-50%)", fontSize: "1.2rem", zIndex: 10 }}
                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
              />
            </div>
            {FormikValueIsValid(formik, "currentPassword") && (
              <div className="p-error mt-2 text-sm">{formik.errors.currentPassword}</div>
            )}
          </div>

          <div className="mb-4">
            <label htmlFor="newPassword" className="block text-900 font-medium mb-2">
              {t("NewPassword")}
            </label>
            <div className="relative w-full">
              <InputText
                id="newPassword"
                type={showNewPassword ? "text" : "password"}
                placeholder={t("NewPassword")}
                className={classNames("w-full p-3 pr-6", {
                  "p-invalid": FormikValueIsValid(formik, "newPassword")
                })}
                value={formik.values.newPassword}
                onChange={(e) => formik.setFieldValue("newPassword", e.target.value)}
              />
              <i
                className={`pi ${showNewPassword ? "pi-eye-slash" : "pi-eye"} cursor-pointer text-600 hover:text-900 absolute`}
                style={{ right: "1rem", top: "50%", transform: "translateY(-50%)", fontSize: "1.2rem", zIndex: 10 }}
                onClick={() => setShowNewPassword(!showNewPassword)}
              />
            </div>
            {FormikValueIsValid(formik, "newPassword") && (
              <div className="p-error mt-2 text-sm">{formik.errors.newPassword}</div>
            )}
          </div>

          <div className="w-full mt-4">
            <Button label={t("ChangePassword")} className="w-full p-3 text-base font-semibold" type="submit" />
          </div>
        </div>
      </div>
    </form>
  );
};

export default ChangePasswordPage;
